function t(e) {
  if (e) return e == null ? void 0 : e.toString().replace(/\D/g, "").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})/, "$1-$2").replace(/(-\d{2})\d+$/, "$1");
}
function c(e) {
  if (e) {
    let r = e.toString().replace(/\D/g, "");
    return r = r.slice(0, 14), r.replace(/(\d{2})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1/$2").replace(/(\d{4})(\d)/, "$1-$2");
  }
}
function n(e) {
  if (e) return e.toString().replace(/\D/g, "").replace(/(\d{2})(\d)/, "($1) $2").replace(/(\d{4})(\d)/, "$1-$2").replace(/(\d{4})-(\d)(\d{4})/, "$1$2-$3").replace(/(-\d{4})\d+$/, "$1");
}
function i(e) {
  if (e) {
    let r = e.toString().replace(/\D/g, "");
    return r = r.slice(0, 8), r.toString().replace(/(\d{2})(\d{2})(\d{4})/, "$1/$2/$3");
  }
}
function a(e) {
  if (e) {
    const r = e.toString().replace(/\D/g, "");
    return r.substring(0, 5) + (r.length > 5 ? "-" + r.substring(5, 8) : "");
  }
}
const d = e => {
  if (e) {
    const r = e.toString().replace(/\D/g, "");
    return (Number(r) / 100).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
};
export { a as cepMask, c as cnpjMask, t as cpfMask, d as currencyBRMask, i as dateMask, n as phoneMask };